import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfigImportService } from '../../../../swaggerServices';
import { TenantConfigService } from '../../../shared/services/tenant-config.service';
import { ConfigStateService } from '../../config/config-state.service';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-config-import',
    templateUrl: './config-import.component.html',
    styleUrls: ['./config-import.component.scss'],
    standalone: false
})
export class ConfigImportComponent implements OnInit {
  @ViewChild('modal') modal: ElementRef;
  @ViewChild('configFileUpload') configFileUpload: ElementRef;

  configFile: File;
  modalMessage: { success?: {message?: any}, error?: {message?: string} };
  isLoading = false;
  taxReturnAlias: string;
  uiConfig: TenantConfigService;
  subscriptions: Subscription[] = [];
  countryAlias: string;

  support = false;


  constructor(
    public config: ConfigStateService,
    private configImportService: ConfigImportService,
    private activatedRoute: ActivatedRoute,) {
   }

  ngOnInit() {
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
        this.countryAlias = `- ${this.uiConfig.config.countryAlias}`
      })
    );
    this.support = !!this.activatedRoute.snapshot.queryParams.support;
  }

  // validates for json file format
  initFile(files: any) {
    this.configFile = undefined;

    const pattern = (/\.(json)$/i);
    const isValidType = pattern.test(files[0].name);

    if (!isValidType) {
      this.modalMessage = {
        error: {
          message: "Please upload a file in .json format"
        }
      };
      $(this.modal.nativeElement).modal('show');
    } else {
      this.configFile = files[0];
    }
  }

  upload() {
    this.isLoading = true;
    this.configImportService.uploadConfig(this.configFile, this.support).subscribe((r) => {
      this.isLoading = false;
      this.modalMessage = {
        success: {
          message: r
        }
      };
      $(this.modal.nativeElement).modal('show');
      this.configFileUpload.nativeElement.value = '';
      this.configFile = undefined;
    }, (err) => {
      this.isLoading = false;
      let message
      if(Array.isArray(err.error)) { message = err.error; }
      else if (err.error && typeof err.error === 'object' && err.error !== null) { message = err.error.message; }

      this.modalMessage = {
        error: {
          message
        }
      };
      $(this.modal.nativeElement).modal('show');
      this.configFileUpload.nativeElement.value = '';
      this.configFile = undefined;
    });
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
